import * as React from 'react';
import { IListViewColumn } from "../../../../../services/ViewService";
import { ProjectInfo } from "../../../../../store/ProjectsListStore";
import EntityName from '../EntityName';

export default class Calendar extends React.Component<IListViewColumn<ProjectInfo>> {
    public render() {
        const { entity, isTimelineView } = this.props;
        const calendarInfo = entity.settings.calendar;
        return <div className="icons-box">
            <EntityName
                key={calendarInfo.id}
                name={calendarInfo.name}
                isTimelineView={isTimelineView}
                url={`/calendar/${calendarInfo.id}`}
                imageClassName='calendar-logo'
            />
        </div>;
    }

    public static getValue(entity: ProjectInfo): string | undefined {
        return entity.settings.calendar?.name;
    }

    public static getSearchValue(entity: ProjectInfo): string | undefined {
        return entity.settings.calendar?.name;
    }
}